import { Component, OnInit } from '@angular/core';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { VrstaVozila } from './vrsta-vozila';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-vrsta-vozila-update',
  templateUrl: './vrsta-vozila-update.component.html'
})
export class VrstaVozilaUpdateComponent extends BaseUpdateComponent<VrstaVozila> 
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'VRSTAVOZILA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'VRSTAVOZILA.NAZIV.VALIDATION.MAXLENGTH');
    }

}
